'use es6';

import { createContext } from 'react';
export const ForwardingContext = /*#__PURE__*/createContext({
  forwardingEnabled: false
});